// src/pages/AssignDoctor.jsx
import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Card,
  CardContent,
  MenuItem,
  Select,
  Typography,
  Snackbar,
  Alert,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TextField,
} from "@mui/material";
import dayjs from "dayjs";
import axios from "axios";

import { decrypt } from "../../components/cryptoUtil";
import { Heading } from "../componenet/heading";
import { API_BASE_URL } from "../../constant/constant";

import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";

const dutyTypes = ["OPD", "IPD", "Emergency", "None"];
const dutyStatus = ["Present", "Leave", "Holiday", "WeeklyHoliday","Absent"];

export default function AssignDoctor() {
  let decryptedData = {};
  try {
    const tokenData = localStorage.getItem("tokenData");
    decryptedData = tokenData ? JSON.parse(decrypt(tokenData)) : {};
  } catch (e) {
    console.warn("Failed to decrypt tokenData", e);
    decryptedData = {};
  }
  const token = localStorage.getItem("token") || "";
  const hospitalId = decryptedData.softsubgroup || "";
  const loggedInUserId = decryptedData.userId || "";

  const [doctors, setDoctors] = useState([]);
  const [personId, setPersonId] = useState(null);
  const [monthDays, setMonthDays] = useState([]);
  const [selectedMonth, setSelectedMonth] = useState(dayjs().month());
  const [selectedYear, setSelectedYear] = useState(dayjs().year());
  const [assignments, setAssignments] = useState({});
  const [weeklyHoliday, setWeeklyHoliday] = useState("");
  const [alert, setAlert] = useState({ open: false, type: "success", msg: "" });

  const [dutyStart, setDutyStart] = useState("09:00");
  const [dutyEnd, setDutyEnd] = useState("17:00");
  const [bulkDutyType, setBulkDutyType] = useState("");

  // Fetch doctors
  useEffect(() => {
    const fetchDoctors = async () => {
      try {
        const res = await fetch(
          `${API_BASE_URL}/api/hospital/listdoctors/${hospitalId}`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        const data = await res.json();
        setDoctors(data);
      } catch (err) {
        console.error(err);
        setAlert({
          open: true,
          type: "error",
          msg: "Failed to fetch doctors",
        });
      }
    };
    fetchDoctors();
  }, [hospitalId, token]);

  // Generate month days whenever month/year changes
  useEffect(() => {
    const today = dayjs();
    const firstDay = dayjs(`${selectedYear}-${selectedMonth + 1}-01`);
    const daysInMonth = firstDay.daysInMonth();
    const daysArray = [];
    for (let d = 1; d <= daysInMonth; d++) {
      const dateObj = dayjs(`${selectedYear}-${selectedMonth + 1}-${d}`);
      if (dateObj.isBefore(today, "day")) continue; // skip past dates
      daysArray.push({
        date: dateObj.format("YYYY-MM-DD"),
        dayName: dateObj.format("dddd"),
      });
    }
    setMonthDays(daysArray);

    const initialAssignments = {};
    daysArray.forEach((day) => {
      initialAssignments[day.date] = [
        {
          dutyType: "OPD",
          dutyStatus: "Present",
          dutyStart: `${day.date} ${dutyStart}`,
          dutyEnd: `${day.date} ${dutyEnd}`,
          disabled: false, // new property to track if row is editable
        },
      ];
    });
    setAssignments(initialAssignments);
  }, [selectedMonth, selectedYear, dutyStart, dutyEnd]);






///GET OD Duties

useEffect(() => {
  if (!personId || !selectedMonth || !selectedYear) return;

  // 1. Generate month days
  const today = dayjs();
  const firstDay = dayjs(`${selectedYear}-${selectedMonth + 1}-01`);
  const daysInMonth = firstDay.daysInMonth();
  const daysArray = [];
  for (let d = 1; d <= daysInMonth; d++) {
    const dateObj = dayjs(`${selectedYear}-${selectedMonth + 1}-${d}`);
    if (dateObj.isBefore(today, "day")) continue; // skip past dates if needed
    daysArray.push({
      date: dateObj.format("YYYY-MM-DD"),
      dayName: dateObj.format("dddd"),
    });
  }
  setMonthDays(daysArray);

  // 2. Fetch existing assignments for this doctor/month
  const fetchAssignments = async () => {
    try {
      const res = await axios.get(`${API_BASE_URL}/api/hospital/getdoctorduties`, {
        params: {
          hospitalId,
          personId: "D" + personId,
          month: selectedMonth + 1,
          year: selectedYear,
        },
        headers: { Authorization: `Bearer ${token}` },
      });

      let newAssignments = {};

      if (res.data.exists) {
        // API has data → normalize it
        Object.entries(res.data.data).forEach(([key, value]) => {
          const formattedKey = dayjs(key).format("YYYY-MM-DD");
          newAssignments[formattedKey] = value.map((duty) => {
            const start = dayjs(`${formattedKey} ${duty.dutyStart}`);
            const end = dayjs(`${formattedKey} ${duty.dutyEnd}`);
            return {
              ...duty,
              dutyStart: start.format("YYYY-MM-DD HH:mm"),
              dutyEnd: end.format("YYYY-MM-DD HH:mm"),
              dutyStatus: duty.dutyStatus,
              disabled: duty.disabled ?? false,
            };
          });
        });
        setAlert({ open: true, type: "info", msg: "Loaded existing duties for selected month"});
      } else {
        // No data → initialize default
        daysArray.forEach((day) => {
          newAssignments[day.date] = [
            {
              dutyType: "OPD",
              dutyStatus: "Present",
              dutyStart: `${day.date} ${dutyStart}`,
              dutyEnd: `${day.date} ${dutyEnd}`,
              disabled: false,
            },
          ];
        });
      }

      setAssignments(newAssignments);
    } catch (err) {
      console.error(err);
      setAlert({ open: true, type: "error", msg: "Failed to fetch doctor duties" });
    }
  };

  fetchAssignments();
}, [personId, selectedMonth, selectedYear, dutyStart, dutyEnd]);




// Apply weekly holiday (editable now)


useEffect(() => {
  if (!weeklyHoliday) return;
  const updated = { ...assignments };
  monthDays.forEach((day) => {
    const dayAssignments = updated[day.date] || [];
    dayAssignments.forEach((assign, idx) => {
      if (day.dayName === weeklyHoliday) {
        dayAssignments[idx] = {
          ...assign,
          dutyType: "None",
          dutyStatus: "WeeklyHoliday",
          dutyStart: `${day.date} 00:00`,
          dutyEnd: `${day.date} 00:00`,
          disabled: true,
        };
      } else if (assign.dutyStatus === "WeeklyHoliday") {
        // Reset previously marked weekly holidays to default
        dayAssignments[idx] = {
          ...assign,
          dutyType: "OPD",
          dutyStatus: "Present",
          dutyStart: `${day.date} ${dutyStart}`,
          dutyEnd: `${day.date} ${dutyEnd}`,
          disabled: false,
        };
      }
    });
    updated[day.date] = dayAssignments;
  });
  setAssignments(updated);
}, [weeklyHoliday, monthDays]);





const handleChange = (date, index, field, value) => {
  setAssignments((prev) => {
    const dayAssignments = [...prev[date]];
    const updated = { ...dayAssignments[index] };

    if (field === "dutyStatus") {
      updated.dutyStatus = value;

      if (value != "Present") {
        updated.dutyType = "None";
        updated.dutyStart = `${date} 00:00`;
        updated.dutyEnd = `${date} 00:00`;
       // updated.disabled = true; // disable editing this row
      } 
      // else if (value !== "Present") {
      //   updated.dutyType = "None";
      //   updated.disabled = false;
      //} 
      else {
        // If status is Present, ensure valid type and enable editing
        updated.disabled = false;
        if (updated.dutyType === "None") {
          updated.dutyType = "OPD";
          updated.dutyStart = `${date} 09:00`;
        updated.dutyEnd = `${date} 17:00`;
         // setAlert({ open: true, type: "error", msg: "Duty Type cannot be None for Present status. Reset to OPD." });
        }
      }
    } 
    else if (field === "dutyType") {
      if (updated.dutyStatus === "Present" && value === "None") {
        updated.dutyType = "OPD";
        setAlert({ open: true, type: "error", msg: "Duty Type cannot be None for Present status. Reset to OPD." });
      } else {
        updated.dutyType = value;
      }
    } 
    else if (field === "dutyStart") {
      if (updated.dutyStatus === "WeeklyHoliday") return prev; // don't allow editing
      const prevDutyEnd = index > 0 ? dayAssignments[index - 1].dutyEnd : null;
      if (prevDutyEnd && dayjs(value).isBefore(dayjs(prevDutyEnd))) {
        setAlert({ open: true, type: "error", msg: "Duty cannot start before previous duty ends!" });
        return prev;
      }
      updated.dutyStart = value;
    } 
    else if (field === "dutyEnd") {
      if (updated.dutyStatus === "WeeklyHoliday") return prev; // don't allow editing
      const nextDuty = dayAssignments[index + 1];
      if (nextDuty && dayjs(value).isAfter(dayjs(nextDuty.dutyStart))) {
        setAlert({ open: true, type: "error", msg: "Duty cannot end after next duty starts!" });
        return prev;
      }
      updated.dutyEnd = value;
    }

    dayAssignments[index] = updated;
    return { ...prev, [date]: dayAssignments };
  });
};



  // Add new duty row after current and disable current
  const handleAddDuty = (date, index) => {
    setAssignments((prev) => {
      const dayAssignments = [...prev[date]];
      const prevDuty = dayAssignments[index];
      const prevEnd = dayjs(prevDuty.dutyEnd);

      // Disable current row
      dayAssignments[index] = { ...prevDuty, disabled: true };

      const newStart = prevEnd;
      const newEnd = newStart.add(2, "hour");

      dayAssignments.splice(index + 1, 0, {
        dutyStart: newStart.format("YYYY-MM-DD HH:mm"),
        dutyEnd: newEnd.format("YYYY-MM-DD HH:mm"),
        dutyStatus: "Present",
        dutyType: prevDuty.dutyType,
        disabled: false,
      });

      return { ...prev, [date]: dayAssignments };
    });
  };

  // Delete duty row and enable previous
  const handleDeleteDuty = (date, index) => {
    setAssignments((prev) => {
      const dayAssignments = [...prev[date]];
      if (dayAssignments.length <= 1) return prev;

      dayAssignments.splice(index, 1);

      // Enable previous row if exists
      if (index - 1 >= 0) {
        dayAssignments[index - 1] = { ...dayAssignments[index - 1], disabled: false };
      }

      return { ...prev, [date]: dayAssignments };
    });
  };

  const handleSave = async () => {
    if (!personId) {
      setAlert({ open: true, type: "error", msg: "Select a doctor first" });
      return;
    }
    try {
      await axios.post(
        `${API_BASE_URL}/api/hospital/assigndoctorsduty`,
        {

          
          hospitalId,
          assignedBy: loggedInUserId,
          personId: "D" + personId,
          assignments,
        },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      setAlert({ open: true, type: "success", msg: "Duties saved successfully" });
    } catch (err) {
      setAlert({ open: true, type: "error", msg: err.response?.data?.error || "Failed to save duties" });
    }
  };

  const current = dayjs();
  const monthOptions = [...Array(3)].map((_, i) => {
    const date = current.add(i, "month");
    return { month: date.month(), year: date.year(), label: date.format("MMMM YYYY") };
  });

  return (
    <Card sx={{ mt: 3 }}>
      <CardContent>
        <Heading headingtext="Assign Doctor Duties (Monthly)" />

        {/* Doctor & Month selection */}
        <Box sx={{ display: "flex", gap: 2, flexDirection: { xs: "column", sm: "row" }, flexWrap: "wrap", mt: 2 }}>
          <Box sx={{ flex: 1, minWidth: 200 }}>
            <Typography variant="body2">Select Doctor</Typography>
            <Select fullWidth value={personId || ""} onChange={(e) => setPersonId(e.target.value)} sx={{ mb: 2 }}>
              {doctors.map((p) => (
                <MenuItem key={p.doctor_id} value={p.doctor_id}>
                  {p.name} ({p.specializationsname})
                </MenuItem>
              ))}
            </Select>
          </Box>

          <Box sx={{ flex: 1, minWidth: 200 }}>
            <Typography variant="body2">Select Month</Typography>
            <Select
              fullWidth
              value={`${selectedMonth}-${selectedYear}`}
              onChange={(e) => {
                const [m, y] = e.target.value.split("-");
                setSelectedMonth(Number(m));
                setSelectedYear(Number(y));
              }}
              sx={{ mb: 2 }}
            >
              {monthOptions.map((opt) => (
                <MenuItem key={opt.label} value={`${opt.month}-${opt.year}`}>
                  {opt.label}
                </MenuItem>
              ))}
            </Select>
          </Box>
        </Box>

        {/* Weekly Holiday & Bulk Duty Type */}
        <Box sx={{ display: "flex", gap: 2, flexDirection: { xs: "column", sm: "row" }, flexWrap: "wrap", mb: 2 }}>
          <Box sx={{ flex: 1 }}>
            <Typography variant="body2">Weekly Holiday</Typography>
            <Select fullWidth value={weeklyHoliday} onChange={(e) => setWeeklyHoliday(e.target.value)}>
              {["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"].map((day) => (
                <MenuItem key={day} value={day}>
                  {day}
                </MenuItem>
              ))}
            </Select>
          </Box>

          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <TimePicker
              label="Duty Start"
              value={dayjs(dutyStart, "HH:mm")}
              onChange={(newValue) => setDutyStart(newValue.format("HH:mm"))}
              ampm={false}
              format="HH:mm"
              renderInput={(params) => <TextField {...params} fullWidth />}
              sx={{ mt: 2.5 }}
            />
            <TimePicker
              label="Duty End"
              value={dayjs(dutyEnd, "HH:mm")}
              onChange={(newValue) => setDutyEnd(newValue.format("HH:mm"))}
              ampm={false}
              sx={{ mt: 2.5 }}
              format="HH:mm"
              renderInput={(params) => <TextField {...params} fullWidth />}
            />
          </LocalizationProvider>

          <Box sx={{ flex: 1 }}>
            <Typography variant="body2">Bulk Duty Type</Typography>
            <Select
              fullWidth
              value={bulkDutyType}
              displayEmpty
              onChange={(e) => {
                const selectedType = e.target.value;
                setBulkDutyType(selectedType);
                if (!selectedType) return;

                const updated = { ...assignments };
                monthDays.forEach((day) => {
                  const dayAssignments = updated[day.date] || [];
                  dayAssignments.forEach((assign) => {
                    if (assign.dutyStatus === "Present" && !assign.disabled) {
                      assign.dutyType = selectedType;
                    }
                  });
                  updated[day.date] = dayAssignments;
                });
                setAssignments(updated);
              }}
            >
              <MenuItem value="">-- Select Duty Type --</MenuItem>
              {dutyTypes.map((type) => (
                <MenuItem key={type} value={type} disabled={type === "None"}>
                  {type}
                </MenuItem>
              ))}
            </Select>
          </Box>
        </Box>

        {/* Duty Table */}
    
<Box
  sx={{
    maxHeight: 400,
    overflowY: "auto",
    overflowX: "auto",
    mb: 2,
    border: "1px solid gray",
    borderRadius: 1,
  }}
>
  <Table sx={{ minWidth: 800, borderCollapse: "separate" }}>
    <TableHead>
      <TableRow sx={{ backgroundColor: "#1976d2" }}>
        <TableCell sx={{ color: "white", position: "sticky", top: 0, zIndex: 1,backgroundColor: "#1976d2", }}>Date</TableCell>
        <TableCell sx={{ color: "white", position: "sticky", top: 0, zIndex: 1, backgroundColor: "#1976d2", }}>Day</TableCell>
        <TableCell sx={{ color: "white", position: "sticky", top: 0, zIndex: 1, backgroundColor: "#1976d2", }}>Duty Start</TableCell>
        <TableCell sx={{ color: "white", position: "sticky", top: 0, zIndex: 1, backgroundColor: "#1976d2", }}>Duty End</TableCell>
        <TableCell sx={{ color: "white", position: "sticky", top: 0, zIndex: 1, backgroundColor: "#1976d2", }}>Duty Status</TableCell>
        <TableCell sx={{ color: "white", position: "sticky", top: 0, zIndex: 1, backgroundColor: "#1976d2", }}>Duty Type</TableCell>
        <TableCell sx={{ color: "white", position: "sticky", top: 0, zIndex: 1, backgroundColor: "#1976d2", }}>+Duty</TableCell>
      </TableRow>
    </TableHead>

    <TableBody>
      {monthDays.map((day) => {
        const dayAssignments = assignments[day.date] || [];
        return dayAssignments.map((assign, index) => {
          const isHoliday = assign.dutyStatus !== "Present";
          return (
            <TableRow
              key={day.date + "-" + index}
              sx={{
                bgcolor: isHoliday ? "#ffb9c3ff" : "inherit",
                ...(isHoliday
                  ? {}
                  : { "&:hover": { bgcolor: "#e0f7fa", cursor: "pointer" } }),
              }}
            >
              {index === 0 && <TableCell rowSpan={dayAssignments.length}>{day.date}</TableCell>}
              {index === 0 && <TableCell rowSpan={dayAssignments.length}>{day.dayName}</TableCell>}

              <TableCell>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <TimePicker
                    value={dayjs(assign.dutyStart)}
                    onChange={(newValue) =>
                      handleChange(day.date, index, "dutyStart", newValue.format("YYYY-MM-DD HH:mm"))
                    }
                   disabled={assign.disabled || assign.dutyStatus !== "Present"}

                    ampm={false}
                    format="HH:mm"
                    renderInput={(params) => <TextField {...params} fullWidth />}
                  />
                </LocalizationProvider>
              </TableCell>

              <TableCell>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <TimePicker
                    value={dayjs(assign.dutyEnd)}
                    onChange={(newValue) =>
                      handleChange(day.date, index, "dutyEnd", newValue.format("YYYY-MM-DD HH:mm"))
                    }
                   disabled={assign.disabled || assign.dutyStatus !== "Present"}

                    ampm={false}
                    format="HH:mm"
                    renderInput={(params) => <TextField {...params} fullWidth />}
                  />
                </LocalizationProvider>
              </TableCell>

              <TableCell>
                <Select
                  fullWidth
                  value={assign.dutyStatus}
                  disabled={assign.disabled && assign.dutyStatus !== "WeeklyHoliday"}
                  onChange={(e) => handleChange(day.date, index, "dutyStatus", e.target.value)}
                >
                  {dutyStatus.map((status) => (
                    <MenuItem key={status} value={status}>
                      {status}
                    </MenuItem>
                  ))}
                </Select>
              </TableCell>

              <TableCell>
                <Select
                  fullWidth
                  disabled={
                    (assign.dutyStatus !== "Present" && assign.dutyStatus !== "WeeklyHoliday") ||
                    assign.disabled
                  }
                  value={assign.dutyType}
                  onChange={(e) => handleChange(day.date, index, "dutyType", e.target.value)}
                >
                  {dutyTypes.map((type) => (
                    <MenuItem key={type} value={type}>
                      {type}
                    </MenuItem>
                  ))}
                </Select>
              </TableCell>

              <TableCell>
                <Button
                  size="small"
                  variant="outlined"
                  onClick={() => handleAddDuty(day.date, index)}
                  disabled={assign.disabled}
                  sx={{ mr: 1 }}
                >
                  +Duty
                </Button>
                <Button
                  size="small"
                  color="error"
                  variant="outlined"
                  onClick={() => handleDeleteDuty(day.date, index)}
                  disabled={dayAssignments.length <= 1}
                >
                  Delete
                </Button>
              </TableCell>
            </TableRow>
          );
        });
      })}
    </TableBody>
  </Table>
</Box>






        {/* Save Button */}
        <Box mt={2}>
          <Button variant="contained" fullWidth onClick={handleSave}>
            Save All Duties
          </Button>
        </Box>
      </CardContent>

      {/* Snackbar Alert */}
      <Snackbar open={alert.open} autoHideDuration={4000} onClose={() => setAlert({ ...alert, open: false })}>
        <Alert severity={alert.type}>{alert.msg}</Alert>
      </Snackbar>
    </Card>
  );
}
